import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPackage"><Path d="M8.75 3.75V7.75C8.75 8.57843 9.42157 9.25 10.25 9.25H13.75C14.5784 9.25 15.25 8.57843 15.25 7.75V3.75M13.75 16.25H16.25M3.75 6.75V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H17.25C18.9069 20.25 20.25 18.9069 20.25 17.25V6.75C20.25 5.09315 18.9069 3.75 17.25 3.75H6.75C5.09315 3.75 3.75 5.09315 3.75 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPackage;
